export default "__VITE_ASSET__DCmlIPxz__"